<template>
  <section class="platform-navigation">
    <div
      class="topnav"
      :class="{ showExtraMenu: toggleHamburger }"
      id="myTopnav"
    >
      <div class="container" @click="toggleMenu">
        <div class="bar1"></div>
        <div class="bar2"></div>
        <div class="bar3"></div>
      </div>
      <transition name="fadeIn">
        <div class="mobileNav" v-if="toggleHamburger">
          <div
            v-for="link in links"
            :key="link.linkText"
            class="navLinks"
            @click="toggleMenu"
          >
            <router-link :to="link.link"
              ><v-icon :name="link.icon" scale="1.5"></v-icon>
              <p>{{ link.linkText }}</p></router-link
            >
          </div>
          <div class="logout-wrap" v-on:click="logout">
            <v-icon name="sign-out-alt" scale="1.5"></v-icon>
            <p>Logout</p>
          </div>
        </div>
      </transition>
      <div class="showMenu">
        <div
          v-for="(link) in links"
          :key="link.linkText"
          class="navLinks"
          v-show="link.linkText != 'Settings'"
        >
          <!-- TODO fix - for now need to be inline css to work -->
          <router-link
            style="
              height: 80px;
              width: unset;
              display: flex;
              align-items: center;
              justify-content: center;
            "
            :to="link.link"
            :class="{
              'router-link-active':
                (link.hasOwnProperty('mediaNestedChildren') &&
                  $route.fullPath == '/images') ||
                (link.hasOwnProperty('mediaNestedChildren') &&
                  $route.fullPath == '/pdf-files') ||
                (link.hasOwnProperty('roomsNestedChildren') &&
                  $route.fullPath == '/room-list') ||
                (link.hasOwnProperty('messagesNestedChildren') &&
                  $route.fullPath == '/message-log') ||
                (link.hasOwnProperty('messagesNestedChildren') &&
                  $route.fullPath == '/customization') ||
                (link.hasOwnProperty('statisticsNestedChildren') &&
                  $route.fullPath == '/platform-statistics') ||
                (link.hasOwnProperty('statisticsNestedChildren') &&
                  $route.fullPath == '/voucher-statistics') ||
                (link.hasOwnProperty('settingsNestedChildren') &&
                  $route.fullPath == '/guestbook-settings') ||
                (link.hasOwnProperty('statisticsNestedChildren') &&
                  $route.fullPath == '/form-statistics') ||
                (link.hasOwnProperty('autoMessagesNestedChildren') &&
                  $route.fullPath == '/precheckin-settings') ||
                (link.hasOwnProperty('autoMessagesNestedChildren') &&
                  $route.fullPath == '/checkin-settings') ||
                (link.hasOwnProperty('autoMessagesNestedChildren') &&
                  $route.fullPath == '/checkout-settings') ||
                (link.hasOwnProperty('guests') &&
                  $route.fullPath == '/departed') ||
                (link.hasOwnProperty('guests') &&
                  $route.fullPath == '/arrivals') ||
                (link.hasOwnProperty('editing') &&
                  $route.fullPath == '/editEvent') ||
                (link.hasOwnProperty('autoMessagesNestedChildren') &&
                  $route.fullPath == '/after-stay-settings') ||
                (link.hasOwnProperty('pages') &&
                  $route.fullPath == '/new-page'),
            }"
          >
            <div class="navigation-item">
              <v-icon
                v-if="link.icon"
                class="navigation-item__icon"
                :name="link.icon"
                scale="1.5"
              ></v-icon>
              <div class="navigation-item__text">{{ link.linkText }}</div>
            </div>
          </router-link>
        </div>

        <div class="account-wrapper">
          <div class="logout-wrap" v-on:click="logout">
            <a
              style="
                height: 80px;
                width: unset;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div>
                <v-icon
                  class="navigation-item__icon"
                  name="sign-out-alt"
                  scale="1.5"
                ></v-icon>
                <div>Logout</div>
              </div>
            </a>
          </div>

          <div class="settings-wrap">
            <router-link
              :to="{ name: 'settings' }"
              style="
                height: 80px;
                width: unset;
                display: flex;
                align-items: center;
                justify-content: center;
              "
              :class="{
                'router-link-active': $route.fullPath == '/customization',
              }"
            >
              <div class="navigation-item">
                <v-icon
                  class="navigation-item__icon"
                  name="cog"
                  scale="1.5"
                ></v-icon>
                <div>Settings</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { app } from "@/firebase";

export default {
  data() {
    return {
      links: [
        {
          link: {
            name: "event-list",
          },
          icon: "calendar-alt",
          linkText: "Events",
        },
        // {
        //   link: {
        //     name: "statistics",
        //   },
        //   icon: "chart-line",
        //   linkText: "statistics",
        //   statisticsNestedChildren: true,
        // },
        {
          link: {
            name: "rooms",
          },
          icon: "users",
          linkText: "Guests",
          roomsNestedChildren: true,
        },
        // {
        //   link: {
        //     name: "automated-messages",
        //   },
        //   icon: "envelope",
        //   linkText: "Auto messages",
        //   autoMessagesNestedChildren: true,
        // },
        {
          link: {
            name: "pages",
          },
          icon: "file-alt",
          linkText: "Pages",
          pages: true,
        },
        {
          link: {
            name: "media",
          },
          icon: "regular/image",
          linkText: "Media",
          mediaNestedChildren: true,
        },
        {
          link: {
            name: "qr-code",
          },
          icon: "qrcode",
          linkText: "QR Code",
        },
        {
          link: {
            name: "edit",
          },
          icon: "pen",
          linkText: "edit",
          editing: true,
        },
        {
          link: {
            name: "settings",
          },
          icon: "cog",
          linkText: "Settings",
          messagesNestedChildren: true,
        },
      ],
      toggleHamburger: false,
    };
  },
  methods: {
    logout: function () {
      app
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({ name: "login" });
        });
    },
    toggleMenu: function () {
      this.toggleHamburger = !this.toggleHamburger;
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

@media print {
  * {
    visibility: hidden;
  }
}

.navigation-item {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.navigation-item__text {
  height: 100%;
}

.navigation-item__icon {
  height: 24px;
  margin-bottom: 5px;
}

.platform-navigation {
  height: 80px;
  position: relative;
  z-index: 10;
  font-size: 14px;
  text-transform: uppercase;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
}

.router-link-active > .navigation-item {
  margin-top: 5px;
  color: #48b9ba;
}

.router-link-active {
  border-bottom: 5px #48b9ba solid;
}

.mobileNav {
  display: none;
}

.topnav {
  overflow: hidden;
  background-color: #fff;
  height: 100%;
  line-height: 1.15;
  text-align: center;
}

.topnav a,
.topnav a .account-wrapper {
  float: left;
  display: block;
  color: #1f1f1e;
  text-align: center;
  padding: 10px 12px;
  text-decoration: none;
  width: 95px;
}

.topnav .account-wrapper a {
  float: right;
}

.topnav a p,
.logout-wrap .settings-wrap p {
  margin: 0 -6px;
  color: #1f1f1e;
}

.topnav .icon {
  display: none;
}

.logout-wrap .settings-wrap {
  float: right;
  cursor: pointer;
}

@media (max-width: 600px) {
  .navigationFix {
    height: unset;
  }

  .showMenu {
    display: none;
  }

  .mobileNav {
    display: block;
  }

  .container {
    float: right;
    cursor: pointer;
    margin: 5px 10px;
    padding-top: 10px;
  }

  .bar1,
  .bar2,
  .bar3 {
    width: 30px;
    height: 3px;
    background-color: #1f1f1e;
    margin: 6px 0;
    transition: 0.4s;
  }

  .topnav {
    overflow: hidden;
    background-color: #fff;
    padding-bottom: 15px;
  }

  .showExtraMenu {
    height: 500px;
  }

  .navLinks {
    clear: both;
  }

  .topnav a,
  .logout-wrap .settings-wrap {
    font-weight: bold;
    float: none;
    display: flex;
    color: #1f1f1e;
    text-align: center;
    padding: 10px 16px;
    text-decoration: none;
    font-size: 15px;
    width: auto;
  }
  .topnav a p,
  .logout-wrap .settings-wrap p {
    margin: 5px 10px;
    display: inline-block;
  }
  .topnav .icon {
    display: none;
  }

  .logout-wrap .settings-wrap {
    float: none;
    cursor: pointer;
  }
}

.fadeIn-enter-active {
  transition: all 0.3s ease;
}
.fadeIn-enter,
.fadeIn-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
